import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { WarningCircleIcon } from 'images'
import { SecondaryButton, TransparentBgButton } from 'components/Shared/Button'
import ProgressWizard from './ProgressWizard'
import { ErrorCategory } from './testCampaignUtils'

export default function ErrorView({ campaign, onClose, onRetry }) {
  const { t } = useTranslation()

  const errorCategory = campaign.error_category || ErrorCategory.UNKNOWN

  const getErrorGuidance = () => {
    switch (errorCategory) {
      case ErrorCategory.PAYMENT:
        return t(
          'Settings.MetaAccess.TestCampaign.error.paymentGuidance',
          'Please add a payment method to your ad account in Meta Business Manager.',
        )
      case ErrorCategory.PERMISSION:
        return t(
          'Settings.MetaAccess.TestCampaign.error.permissionGuidance',
          'You may need to reconnect with additional permissions. Please ensure you have admin access to the Meta Business Manager account and try reconnecting your account with all requested permissions.',
        )
      default:
        return t(
          'Settings.MetaAccess.TestCampaign.error.unknownGuidance',
          'Please try again or contact support if the issue persists.',
        )
    }
  }

  return (
    <div className="test-campaign-error">
      <div className="test-campaign-error__content">
        <h4 className="modal_inner_header_title m-0 mr-3">
          {t('Settings.MetaAccess.TestCampaign.errorTitle', 'Test Campaign')}
        </h4>

        <div className="test-campaign-error__progress">
          <ProgressWizard campaign={campaign} />
        </div>

        {campaign.error && (
          <div className="test-campaign-error__message-container">
            <div className="test-campaign-error__problem">
              <div className="test-campaign-error__problem-text">
                <div className="test-campaign-error__problem-title">{campaign.error.title}</div>
                <div>{campaign.error.message}</div>
              </div>
            </div>
            <div className="test-campaign-error__solution">
              <WarningCircleIcon width={16} height={16} />
              <span className="test-campaign-error__solution-text">{getErrorGuidance()}</span>
            </div>
          </div>
        )}
      </div>

      <div className="test-campaign-error__footer">
        <div className="d-flex justify-content-between w-100">
          <TransparentBgButton
            text={t('common.close', 'Close')}
            color="navy"
            onClick={onClose}
            fullWidth={false}
          />
          <SecondaryButton
            text={t('common.retry', 'Retry')}
            color="navy"
            onClick={onRetry}
            fullWidth={false}
          />
        </div>
      </div>
    </div>
  )
}

ErrorView.propTypes = {
  campaign: PropTypes.shape({
    campaign_id: PropTypes.string,
    ad_account_id: PropTypes.string.isRequired,
    error: PropTypes.object,
    error_category: PropTypes.string,
    status: PropTypes.string.isRequired,
    stage: PropTypes.string,
  }).isRequired,
  onClose: PropTypes.func.isRequired,
  onRetry: PropTypes.func.isRequired,
}
